import ArrowBackIosNew from "@mui/icons-material/ArrowBackIosNew";
import "./LlePickupDetails.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col, NavItem, Table } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
//import { CommonRegistrationSidebar } from "../../common/common-registration-sidebar/commonRegistrationSidebar";
import { authKey, GET_CONSIGNMENT_DETAILS_BY_NUMBER, GET_UNRESTRICTED_INVENTORY, CONSIGNMENT_PICK_UP_CB_SAVE, TOLERANCE, CREATE_DELIVERY_CHALLAN, PRINT_DOWNLOAD_DATA, GET_STAKEHOLDER_CATEGORY } from '../../../common/URLs';

import { loaderService } from "../../../common/custom-loader/loader-service";
import { useLocation } from "react-router-dom";
import { DialogContent, Dialog, DialogActions, Button, Box, TextField, Grid, Card, CardContent, Divider, FormHelperText } from '@mui/material';
import jwt from 'jwt-decode';
import HeapPopOver from "../chipping/heapPopover";
import BundleDetailsPopOver from '../chipping/bundleDetailsPopOver';
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { PROD, PIT_ROLES, NO_DATA_AVAILABLE } from "../../../common/constants";
import { userData } from '../../../common/spinLoader';
import Moment from 'moment';
import { toast } from 'react-toastify';
import { Fab, Typography } from '@mui/material';
import { KeyboardArrowLeftRounded } from '@mui/icons-material';
import Badge from 'react-bootstrap/Badge';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { DataGrid } from '@mui/x-data-grid';
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import { VALIDATION, capitalizeFunction, weightValidation } from "../../../common/commonValidations";
import { ConfirmationPopover } from "../../../common/commonPopovers/confirmationPopover";
import { handleNumberFieldFocus } from "../../../common/commonFunction";
import { v4 as uuidv4 } from 'uuid';
import apiClient from "../../../axios";

function LleTracker(props) {

  const { state } = useLocation();
  const userLoggedInRole = userData?.user?.userRoles?.[0]?.roleName;
  const navigate = useNavigate();
  const decoded = jwt(getLocalStorageItem('id_token'));
  const [consignmentdetails, setConsignmentdetails] = useState();
  const [consignmentsource, setConsignmentsource] = useState();
  const [pickuprbcb, setPickuprbcb] = useState();
  const [consignmentPickupResponse, setConsignmentPickupResponse] = useState();
  const [chippingOrderList, setChippingOrderList] = useState([]);
  const [selectedHeap, setSelectedHeap] = useState([]);
  const [showGrid, setShowGrid] = useState(true);
  const [rbcbDetails, setRbcbDetails] = useState([]);
  const [newArrayList, setNewArrayList] = useState([]);
  const [totalWeightPickup, setTotalWeightPickup] = useState();
  const [rbInventories, setRbInventories] = useState([]);
  const [selectedBundles, setSelectedBundles] = useState([]);
  const [createDeliveryChallan, setCreateDeliveryChallan] = useState();
  const ConsNumber = useLocation()?.state?.selectedConsNo;
  const [stakeholderDetails, setStakeholderDetails] = useState();

  const [getTolerance, setGetTolerance] = useState([]);
  const [downloadDeliveryChallan, setDownloadDeliveryChallan] = useState();

  const [minimum, setMinimum] = useState();
  const [maximum, setMaximum] = useState();

  const [logModalOpen, setLogModalOpen] = useState(false);
  const handleLogModalOpen = () => setLogModalOpen(true);
  const handleLogModalClose = () => setLogModalOpen(false);
  const [logModalOpen1, setLogModalOpen1] = useState(false);
  const [logModalOpen2, setLogModalOpen2] = useState(false);
  const [logModalOpen3, setlogModalOpen3] = useState(false);
  const [logModalOpen4, setLogModalOpen4] = useState(false);
  const handleLogModalOpen1 = () => setLogModalOpen1(true);
  const handleLogModalClose1 = () => setLogModalOpen1(false);
  const handleLogModalOpen2 = () => setLogModalOpen2(true);
  const handleLogModalClose2 = () => setLogModalOpen2(false);
  const handleLogModalOpen4 = () => setLogModalOpen4(true);
  const handleLogModalClose4 = () => setLogModalOpen4(false);

  const [confirmOpen, setConfirmOpen] = useState(false);
  const handleConfirmOpen = () => setConfirmOpen(true);
  const handleConfirmClose = () => setConfirmOpen(false);

  const [confirmOpen2, setConfirmOpen2] = useState(false);
  const handleConfirmOpen2 = () => setConfirmOpen2(true);
  const handleConfirmClose2 = () => setConfirmOpen2(false);

  const [confirmOpen3, setConfirmOpen3] = useState(false);
  const handleConfirmOpen3 = () => setConfirmOpen3(true);
  const handleConfirmClose3 = () => setConfirmOpen3(false);

  const [confirmOpen4, setConfirmOpen4] = useState(false);
  const handleConfirmOpen4 = () => setConfirmOpen4(true);
  const handleConfirmClose4 = () => setConfirmOpen4(false);

  const [minAvgMoisture, setMinAvgMoisture] = useState(0);
  const [maxAvgMoisture, setMaxAvgMoisture] = useState(0);
  // const [totalPickupWeight, setTotalPickUpWeight] = useState();
  const [role1, setRole1] = useState(false);
  const [role2, setRole2] = useState(false);
  const [consignmentNoDetails, setConsignmentNoDetails] = useState({
    "consignmentNo": useLocation()?.state?.selectedConsNo,
    "pickupTareWeight": "",
    "totalMoisture": "",
    // "pickupAvgChipSize": "",
    "pickupGrossWeight": "",
    "pickupNetWeight": "",
    "totalWeight": "",
    "odometerReading": "",
    "isHitInspectionChecklist": "",
    "isProperLashing": "",
    "isPayloadWithinCapacity": "",
    "isPayloadHeightExceedLimit": "",
    "isTripStarted": "",
    "isLoadingCompleted": "",
    // "pickupComments": "",
  });

  const [errorMessage, setErrorMessage] = useState({
    consignmentNoError: "",
    "pickupTareWeightError": "",
    "totalMoistureError": "",
    // "pickupAvgChipSizeError": "",
    "pickupGrossWeightError": "",
    "pickupNetWeightError": "",
    "totalWeightError": "",
    "odometerReadingError": "",
    "isHitInspectionChecklistError": "",
    "isProperLashingError": "",
    "isPayloadWithinCapacityError": "",
    "isPayloadHeightExceedLimitError": "",
    "isTripStartedError": "",
    "heapError": ""
    // "comments": ""  
  });
  const [characterLimit] = useState(500);
  const [addComment, setAddComment] = useState('');

  const totalWeight = (consignmentNoDetails?.pickupGrossWeight) - (consignmentNoDetails
    ?.pickupTareWeight)

  const commentColumns = [
    { field: "action", headerName: "Action", width: 150 },
    { field: "comment", headerName: "Comment", width: 700 }
  ]

  useEffect(() => {

    toleranceLimit();

  }, [totalWeight]);

  useEffect(() => {
    if (ConsNumber) {
      getConsignmentDetails();
    }
  }, [ConsNumber]);

  const urn = (localStorage.getItem('role') == PIT_ROLES.PitScmUser || stakeholderDetails?.category == 'Transporter') ? consignmentdetails?.consignmentSourceDetails?.[0]?.sourceStakeholderUrn : stakeholderDetails?.urn
  const type = (localStorage.getItem('role') == PIT_ROLES.PitScmUser || stakeholderDetails?.category == 'Transporter') ? consignmentdetails?.consignmentSourceDetails?.[0]?.sourceType : stakeholderDetails?.category

  useEffect(() => {

    if (urn && type) {
      getUnrestrictedInventory();
    }
  }, [urn, type]);

  useEffect(() => {
    if (decoded.extension_URN) getStakeDetails();
  }, [decoded.extension_URN])

  const getStakeDetails = () => {
    loaderService.showLoader()
    apiClient
      .post(GET_STAKEHOLDER_CATEGORY,
        {
          "urn": decoded.extension_URN,
          "type": ""
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setStakeholderDetails(response.data);
        loaderService.hideLoader()
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader()
      });
  }


  const getUnrestrictedInventory = (inventoriesList) => {
    let data = {
      "stakeHolderUrn": urn,
      "stakeHolderType": type,
    };
    let headers = {
      Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
    }
    apiClient
      .post(GET_UNRESTRICTED_INVENTORY, data, { headers })
      .then(res => {
        //setUnrestrictInventory(res.data.inventoryMovementSum);
        setRbInventories(res.data.inventoryMovementSum?.rbInventories)
        // console.log("res.data.inventoryMovementSum?.rbInventories", res.data.inventoryMovementSum?.rbInventories)
        res.data.inventoryMovementSum?.rbInventories.sort((a, b) => {
          if (new Date(a.consignmentDeliveryTimestamp) < new Date(b.consignmentDeliveryTimestamp)) {
            return -1;
          } else {
            return 1;
          }
        })

        res.data.inventoryMovementSum?.rbInventories?.forEach(item => {
          inventoriesList?.forEach(inv => {
            if (item.bundleId === inv.bundleId) {
              item.checkVal = true;
              item.comment = inv.comment;
            }
          })
        })
        setRbInventories(res.data.inventoryMovementSum?.rbInventories)
        // setRbInventories(res.data.inventoryMovementSum?.rbInventories)
        // console.log("res.data.inventoryMovementSum?.rbInventories", res.data.inventoryMovementSum?.rbInventories)
      })
  }

  const setInventories = (inventories) => {

    setRbInventories([...inventories]);
    inventories?.forEach(inv => {
      if (inv.checkVal) {
        inv.isSelected = true;
        inv.comment = null;
      }
    });
    // console.log("skipped")
    // console.log(inventories.filter(bundle => ((!bundle?.checkVal) && bundle?.comment != null && bundle?.comment != "")))
    //setSkippedBundles(inventories.filter(bundle=> ((!bundle?.checkVal) && bundle?.comment!=null && bundle?.comment!="")));
    let selectedbndles = inventories.filter(bundle => bundle.checkVal)
    let unselectedbndles = inventories.filter(bundle => bundle.checkVal === false)
    //setSelectedBundles(inventories.filter(bundle => bundle.checkVal));

    let newArrayListLocal = [...newArrayList]; //rbcbDetails?.concat(selectedHeap) ? rbcbDetails?.concat(selectedHeap) : selectedHeap;
    //newArrayList = newArrayList?.concat(selectedbndles) ? newArrayList?.concat(selectedbndles) : selectedbndles;
    //setNewArrayList(newArrayList);


    let newArrayListUpdated = newArrayListLocal.filter(item => {
      let present = true;
      selectedbndles?.forEach(item1 => {
        if (item1.bundleId === item.bundleId) {
          present = false;
        }
      })
      return present;
    })

    newArrayListUpdated = newArrayListUpdated.filter(item => {
      let present = true;
      unselectedbndles?.forEach(item1 => {
        if (item1.bundleId === item.bundleId) {
          present = false;
        }
      })
      return present;
    })


    selectedbndles?.forEach(
      item => {
        item.consignmentSourceDetailId = item.consignmentId;
        item.rbCbWeight = item.pickupWeight;
        item.avgMoisture = item.pickupMoisture;
        if (item.id) {
          delete item.id;
        }

      })

    newArrayListLocal = newArrayListUpdated?.concat(selectedbndles) ? newArrayListUpdated?.concat(selectedbndles) : selectedbndles;
    // console.log(newArrayListLocal.reduce((total, item) =>
    //   total + (item.rbCbWeight ? item.rbCbWeight : 0)
    //   , 0))
    // setTotalPickUpWeight(
    //   newArrayListLocal.reduce((total, item) =>
    //     total + (item.rbCbWeight ? item.rbCbWeight : 0)
    //     , 0)
    // )
    setNewArrayList(newArrayListLocal);

    // setErrorMessage({ ...errorMessage, heapError: "" });
    //checkVal will be true for selected inventory 
  }



  const handleChange = (e) => {
    weightValidation(e.target.value) && setConsignmentNoDetails({ ...consignmentNoDetails, [e.target.name]: e.target.value });
    weightValidation(e.target.value) && setConsignmentdetails({ ...consignmentdetails, [e.target.name]: e.target.value });
    // if (e.target.value.length > e.target.maxLength)
    //   e.target.value = e.target.value.slice(0, e.target.maxLength);

    setErrorMessage();
    if (e.target.name === "odometerReading") {
      setErrorMessage({ ...errorMessage, odometerReadingError: "" });
    }
    if (e.target.name === "pickupTareWeight") {

      setErrorMessage({ ...errorMessage, pickupTareWeightError: "" });
    }
    if (e.target.name === "totalMoisture") {
      setErrorMessage({ ...errorMessage, totalMoistureError: "" });
    }
    // if (e.target.name === "pickupAvgChipSize") {
    //   setErrorMessage({ ...errorMessage, pickupAvgChipSizeError: "" });
    // }
    if (e.target.name === "pickupGrossWeight") {
      setErrorMessage({ ...errorMessage, pickupGrossWeightError: "" });
    }
    if (e.target.name === "pickupNetWeight") {
      setErrorMessage({ ...errorMessage, pickupNetWeightError: "" });
    }
    // if (e.target.name === "chippingOrderNo") {
    //   setErrorMessage({ ...errorMessage, chippingOrderNoError: "" });
    // }

    if (errorMessage?.totalWeightError === null) {
      setErrorMessage({ ...errorMessage, totalWeightError: "" })
    }

  }
  const onTextValueChange = (e) => {
    setAddComment(VALIDATION.noSpecialCharacterValidation(e.target.value.slice(0, 500)));
  }


  const radioChange = (e, value) => {
    setConsignmentNoDetails({
      ...consignmentNoDetails, [e.target.name]: value,
    })
    if (e.target.name === "isHitInspectionChecklist") {
      setErrorMessage({ ...errorMessage, isHitInspectionChecklistError: "" });
    }
    if (e.target.name === "isProperLashing") {
      setErrorMessage({ ...errorMessage, isProperLashingError: "" });
    }
    if (e.target.name === "isPayloadWithinCapacity") {
      setErrorMessage({ ...errorMessage, isPayloadWithinCapacityError: "" });
    }
    if (e.target.name === "isPayloadHeightExceedLimit") {
      setErrorMessage({ ...errorMessage, isPayloadHeightExceedLimitError: "" });
    }

  };

  useEffect(() => {
    if (consignmentPickupResponse) {
      if (consignmentPickupResponse.isSuccess === true) {
        toast.success(consignmentPickupResponse?.message)
        // handleLogModalOpen1();
      }
      else {
        toast.error(consignmentPickupResponse?.message ? consignmentPickupResponse?.message : "Error")
        // handleLogModalOpen();
      }
    }
  }, [consignmentPickupResponse]);

  useEffect(() => {
    if (userLoggedInRole) {
      if (userLoggedInRole === PIT_ROLES.ProcessingIncharge) {
        setRole1(true);
      }
      if (userLoggedInRole === PIT_ROLES.ProcessingIncharge) {
        setRole2(true);
      }
    }
  })


  const onConfirmSave = (e) => {
    handleConfirmClose();
    consignment_pickup_cb_save(false, false);
    // onSave(e);
  }

  const onSaveButtonClick = (e) => {
    handleConfirmOpen();
  }

  const onConfirmCreateDeliveryChallan = (e) => {
    handleConfirmClose2();
    toCreateDeliveryChallan();
    // onDeliveryChallan(e);
  }

  const onCreate = (e) => {
    handleConfirmOpen2();
  }

  const onConfirmStartTrip = (e) => {
    handleConfirmClose3();
    consignment_pickup_cb_save(true, true);
    // onStart(e);
  }

  const onStartDestinationTrip = (e) => {
    handleConfirmOpen3();

  }

  const onConfirmLoadingCompleted = (e) => {
    handleConfirmClose4();
    consignment_pickup_cb_save(false, true);
  }

  const onLoadingCompleted = (e) => {
    handleConfirmOpen4();
  }


  const onSave = (e) => {
    // console.log("heapppp")
    if (!consignmentNoDetails.consignmentNo) {
      setErrorMessage({ ...errorMessage, consignmentNoError: "Please Enter Consignment Number" })
    }
    else if (errorMessage.totalWeightError !== '') {
      setErrorMessage({ ...errorMessage, totalWeightError: `Value must be within ${minimum} and ${maximum} ` });
    }
    else {
      onSaveButtonClick();
      // consignment_pickup_cb_save(false, false);
      // consignment_pickup_cb_save(false, consignmentdetails?.loadingCompleteDate === null ? null : consignmentdetails?.loadingCompleteDate === false ? false : true);
    }
  }

  const onLoading = (e) => {
    if (!consignmentNoDetails?.pickupTareWeight) {
      setErrorMessage({ ...errorMessage, pickupTareWeightError: "Please enter Tare weight measured @LLE(in MT)" })
    }
    else if (!consignmentNoDetails?.pickupGrossWeight) {
      setErrorMessage({ ...errorMessage, pickupGrossWeightError: "Please enter Gross Weight" })
    }
    // else if (!consignmentNoDetails?.totalMoisture) {
    //   setErrorMessage({ ...errorMessage, totalMoistureError: "Please enter Average Moisture" })
    // }
    else if (errorMessage.totalWeightError !== '') {
      setErrorMessage({ ...errorMessage, totalWeightError: `Value must be within ${minimum} and ${maximum} ` });
    }
    else {
      // consignment_pickup_cb_save(false, true);
      onLoadingCompleted();
    }
  }

  const onStart = (e) => {
    e.preventDefault();
    // if ((consignmentNoDetails?.pickupTareWeight) && (consignmentNoDetails?.totalMoisture) && (consignmentNoDetails?.pickupGrossWeight) && (consignmentNoDetails?.pickupNetWeight) && (consignmentNoDetails?.odometerReading) && (consignmentNoDetails?.isHitInspectionChecklist != null) && (consignmentNoDetails?.isProperLashing != null) && (consignmentNoDetails?.isPayloadWithinCapacity != null) && (consignmentNoDetails?.isPayloadHeightExceedLimit != null) && (errorMessage?.totalWeightError === "") && newArrayList) {
    if (newArrayList.length != 0) {
      onStartDestinationTrip();
      // consignment_pickup_cb_save(true, true);
      // console.log(newArrayList);
    }
    else {
      if (newArrayList.length === 0) {
        setErrorMessage({ ...errorMessage, heapError: "Please select bundle" });
      }
      if (errorMessage.totalWeightError !== '') {
        setErrorMessage({ ...errorMessage, totalWeightError: `Value must be within ${minimum} and ${maximum} ` });
      }
      if (consignmentNoDetails?.isPayloadHeightExceedLimit === null) {
        setErrorMessage({ ...errorMessage, isPayloadHeightExceedLimitError: "Please select" });
      }
      if (consignmentNoDetails?.isPayloadWithinCapacity === null) {
        setErrorMessage({ ...errorMessage, isPayloadWithinCapacityError: "Please select" });
      }

      if (consignmentNoDetails?.isProperLashing === null) {
        setErrorMessage({ ...errorMessage, isProperLashingError: "Please select" });
      }
      if (consignmentNoDetails.isHitInspectionChecklist === null) {
        setErrorMessage({ ...errorMessage, isHitInspectionChecklistError: "Please select" });
      }
      if (!consignmentNoDetails?.odometerReading) {
        setErrorMessage({ ...errorMessage, odometerReadingError: "Please enter Odometer Start Reading" })
      }
      if (!consignmentNoDetails?.pickupGrossWeight) {
        setErrorMessage({ ...errorMessage, pickupGrossWeightError: "Please enter Gross Weight" })
      }
      //   if (!consignmentNoDetails?.pickupAvgChipSize) {
      //     setErrorMessage({ ...errorMessage, pickupAvgChipSizeError: "Please enter Average Chip Size" })
      //   }
      // if (!consignmentNoDetails?.totalMoisture) {
      //   setErrorMessage({ ...errorMessage, totalMoistureError: "Please enter Average Moisture" })
      // }
      if (!consignmentNoDetails?.pickupTareWeight) {
        setErrorMessage({ ...errorMessage, pickupTareWeightError: "Please enter Tare Weight" })
      }
    }

  }

  const getDetails = (e) => {
    e.preventDefault();
    if (!consignmentNoDetails.consignmentNo) {
      setErrorMessage({ ...errorMessage, consignmentNoError: "Please Enter Consignment Number" })
    }
    else {
      getConsignmentDetails();
    }
  }

  const getConsignmentDetails = () => {
    apiClient
      .post(GET_CONSIGNMENT_DETAILS_BY_NUMBER,
        {
          "consignmentNumber": ConsNumber,
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setConsignmentdetails(response.data);
        // getUnrestrictedInventory(response.data.consignmentSourceDetails?.[0]?.consignmentPickupRbCbs);
        setConsignmentNoDetails({
          ...consignmentNoDetails,
          "odometerReading": response.data.consignmentMilestones?.[0]?.odometerReading,
          "pickupComments": response.data.pickupComments,
          "pickupTareWeight": response.data.pickupTareWeight,
          "totalMoisture": response.data.totalMoisture,
          // "pickupAvgChipSize": response.data.pickupAvgChipSize,
          "pickupGrossWeight": response.data.pickupGrossWeight,
          "pickupNetWeight": response.data.pickupNetWeight,
          "totalWeight": response.data.totalWeight,
          "isHitInspectionChecklist": response.data.consignmentSourceDetails[0].isHitInspectionChecklist,
          "isProperLashing": response.data.consignmentSourceDetails[0].isProperLashing,
          "isPayloadWithinCapacity": response.data.consignmentSourceDetails[0].isPayloadWithinCapacity,
          "isPayloadHeightExceedLimit": response.data.consignmentSourceDetails[0].isPayloadHeightExceedLimit,
          "isTripStarted": response.data.isTripStarted,
          "isLoadingCompleted": response.data.isLoadingCompleted,
          "cbPickupList": response.data.consignmentSourceDetails?.[0]?.consignmentPickupRbCbs,
        })
        // setTotalPickUpWeight(response.data.pickupNetWeight);
        setConsignmentsource(response.data.consignmentSourceDetails[0]);
        setRbcbDetails(response.data.consignmentSourceDetails?.[0]?.consignmentPickupRbCbs);
        setSelectedBundles(response.data.consignmentSourceDetails?.[0]?.consignmentPickupRbCbs);
        setNewArrayList(response.data.consignmentSourceDetails?.[0]?.consignmentPickupRbCbs)
        // setAddComment(response.data.pickupComments);
      })
      .catch(function (error) {
        console.log(error);
        toast.error(error.message);
      });
  }

  const totalPickupWeight = Number(newArrayList?.reduce((accum, bundle) => Number(accum) + Number(bundle.rbCbWeight), consignmentNoDetails?.pickupNetWeight));


  const consignment_pickup_cb_save = (tripStarted, loadingDone) => {

    loaderService.showLoader();
    apiClient
      .post(
        CONSIGNMENT_PICK_UP_CB_SAVE,
        {
          "consignmentNo": consignmentNoDetails?.consignmentNo,
          "pickupTareWeight": consignmentNoDetails?.pickupTareWeight,
          "totalMoisture": consignmentNoDetails?.totalMoisture,
          // "pickupAvgChipSize": consignmentNoDetails?.pickupAvgChipSize,
          "pickupGrossWeight": consignmentNoDetails?.pickupGrossWeight,
          "pickupNetWeight": totalPickupWeight,
          "totalWeight": totalWeight,
          // "pickupNetWeight": consignmentNoDetails?.pickupNetWeight ? consignmentNoDetails?.pickupNetWeight : (consignmentNoDetails?.pickupNetWeight) + Number(totalPickupWeight),           
          // "totalWeight": consignmentNoDetails?.pickupNetWeight ? consignmentNoDetails?.pickupNetWeight : (consignmentNoDetails?.pickupNetWeight) + Number(totalPickupWeight),            
          "odometerReading": consignmentNoDetails?.odometerReading,
          "isInspectionChecklist": consignmentNoDetails?.isHitInspectionChecklist,
          "isProperLashing": consignmentNoDetails?.isProperLashing,
          "isPayloadWithinCapacity": consignmentNoDetails?.isPayloadWithinCapacity,
          "isPayloadHeightExceedLimit": consignmentNoDetails?.isPayloadHeightExceedLimit,
          "isTripStarted": tripStarted,
          "isLoadingDone": loadingDone,
          "comments": addComment,
          "isPickupBundlesSelected": true,
          "cbPickupList": [
            ...newArrayList

          ]

        },
        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem('id_token'),
          },
        }
      )
      .then((response) => {
        console.log(response.data)
        setConsignmentdetails(response.data);
        setRbcbDetails(consignmentdetails?.consignmentSourceDetails?.[0]?.consignmentPickupRbCbs);
        setConsignmentPickupResponse(response.data);
        loaderService.hideLoader();
        navigate('/dashboardHome/inventoryType')
      })
      .catch(function (error) {
        console.log("apiClientERROR", error);
        loaderService.hideLoader();
        toast.error(error.message);
      });
  };

  const getselectedHeapDetails = (heapList) => {
    let selectedHeap = heapList.filter(heap => heap.checkVal)
    setSelectedHeap(selectedHeap);
    let newArrayList = [...rbcbDetails]; //rbcbDetails?.concat(selectedHeap) ? rbcbDetails?.concat(selectedHeap) : selectedHeap;
    newArrayList = newArrayList?.concat(selectedHeap) ? newArrayList?.concat(selectedHeap) : selectedHeap;
    setNewArrayList(newArrayList);
    setErrorMessage({ ...errorMessage, heapError: "" });
  }

  const onClickBundle = (onClose) => {
    // props.selectedHeap();
    // confirmAlert({
    //   customUI: ({ onClose }) => {
    //     return (
    //       <BundleDetailsPopOver inventories={setInventories} rbInventories={rbInventories} onClose={onClose} />
    //     );
    //   }
    // });
    handleLogModalOpen4(onClose);
  }

  // const addBamboo = (e, selectedSpecies, otherSpeciesName) => {
  //   setEditSpecies(selectedSpecies)
  //   setSpeciesName(otherSpeciesName)
  //   handleLogModalOpen();
  // }

  const onDeliveryChallan = (e) => {
    e.preventDefault();
    if (!consignmentNoDetails.consignmentNo) {
      setErrorMessage({ ...errorMessage, consignmentNoError: "Please Enter Consignment Number" })
    }
    else {
      // toCreateDeliveryChallan();
      onCreate();
    }
  }

  const toCreateDeliveryChallan = (e) => {
    loaderService.showLoader();
    apiClient
      .post(CREATE_DELIVERY_CHALLAN,
        {
          "consignmentNo": consignmentNoDetails?.consignmentNo,
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setCreateDeliveryChallan(response.data);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }

  useEffect(() => {
    if (createDeliveryChallan) {
      if (createDeliveryChallan.isSuccess === true) {
        toast.success(createDeliveryChallan?.message)
        // handleLogModalOpen2();
      }
      else {
        toast.error(createDeliveryChallan?.message ? createDeliveryChallan?.message : "Error")
        // setlogModalOpen3(true);
      }
    }
  }, [createDeliveryChallan]);

  const toleranceLimit = () => {
    loaderService.showLoader();
    apiClient
      .post(
        TOLERANCE,
        {

        },
        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem('id_token'),
          },
        }
      )
      .then((response) => {
        setGetTolerance(response.data.qualityManagedToleranceLimitList)
        //console.log("tol", getTolerance)
        let tolWeightLimit = 0;
        let avgMoistureLimit = 0;
        response.data.qualityManagedToleranceLimitList?.forEach(tl => {
          if (tl.materialCode === "RawBamboo") {
            if (tl.qualityParameter === "Weight") {
              tolWeightLimit = tl.toleranceLimit;
            }
            if (tl.qualityParameter === "AvgMoisture") {
              avgMoistureLimit = tl.toleranceLimit;
            }
          }

        })
        let value = (consignmentdetails?.consignmentWeight)
        let tolerance = (value * tolWeightLimit) / 100;
        //let toleranceAvgMoisture = (consignmentdetails?.destinationTotalMoisture / 100) * avgMoistureLimit


        const minValue = value - tolerance;
        const maxValue = value + tolerance;
        //setMinAvgMoisture(consignmentdetails?.destinationTotalMoisture - toleranceAvgMoisture)
        //setMaxAvgMoisture(consignmentdetails?.destinationTotalMoisture + toleranceAvgMoisture)
        if (totalWeight > maxValue || totalWeight < minValue) {
          setErrorMessage({ ...errorMessage, totalWeightError: `Value must be within ${minValue} and ${maxValue} ` });
        } else {
          setErrorMessage({ ...errorMessage, totalWeightError: "" });
          setMinimum(minValue);
          setMaximum(maxValue);
          setTotalWeightPickup(totalWeight);

        }

        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log("apiClientERROR", error);
        loaderService.hideLoader();
        toast.error(error.message);
      });
  };

  const getDownloadChallan = (action) => {
    loaderService.showLoader();
    apiClient
      .post(PRINT_DOWNLOAD_DATA,
        {
          "printDataByNumber": consignmentdetails?.delieryChallanNumber,
          "printDetailsType": "delivery_challan",
        },
        {
          responseType: 'blob',
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),

            Accept: 'application/pdf'
          }
        }, null
      )
      .then((response) => {
        setDownloadDeliveryChallan(response.data);
        const url = URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));

        if (action === "download") {
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `Output.pdf`
          );
          document.body.appendChild(link);

          link.click();
          link.parentNode.removeChild(link);
        }
        if (action === "print") {
          let iframe = document.createElement('iframe');
          document.body.appendChild(iframe);
          iframe.style.display = 'none';
          iframe.src = url;
          iframe.onload = function () {
            setTimeout(function () {
              iframe.focus();
              iframe.contentWindow.print();
            }, 1);
          };
        }
        loaderService.hideLoader();
      }).catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }
  // const totalPickupWeightBundleSelection = Number(newArrayList?.reduce((accum, heap) => Number(accum) + Number(heap.rbCbWeight), consignmentNoDetails?.pickupNetWeight));

  const columns = [
    { field: 'bundleId', headerName: 'Bundle ID', width: 180 },
    {
      field: 'arrivalMoisture', headerName: 'Moisture', width: 180,
      valueGetter: (params) => {
        return params.row.arrivalMoisture ? Number(params.row.arrivalMoisture)?.toFixed(2) : Number(params.row?.avgMoisture)?.toFixed(4)
      }
    },
    {
      field: 'rbCbWeight', headerName: 'Weight', width: 150,
      valueGetter: (params) => {
        return params.row.arrivalWeight ? Number(params.row.arrivalWeight)?.toFixed(2) : Number(params.row?.rbCbWeight)?.toFixed(4)
      }
    },
  ];


  return (
    <>
      <Container maxWidth="xxl">
        {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>PIT45</p>}
        <Typography variant="h4" gutterBottom>
          <Fab onClick={() => { navigate(-1) }} size="small" aria-label="back" title='Back'>
            <KeyboardArrowLeftRounded />
          </Fab> Consignment Pick Up/Tracker
        </Typography>
        <Card>
          <CardContent>
            <Grid container spacing={1} direction="row" mt={1}>
              <Grid item xs={12}>
                <Grid container spacing={3}>
                  <Grid item xs={12} lg={4}>
                    <TextField fullWidth size="small" label='Consignment No' type="text" value={consignmentdetails?.consignmentNo || ''} name="consignmentNo" disabled={true} onChange={(e) => handleChange(e)} />
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <TextField fullWidth size="small" label='Consignment Status' type="text" value={consignmentdetails?.consignmentStatus || ''} disabled />
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <TextField fullWidth size="small" label="Transporter URN" type="text" value={consignmentdetails?.consignmentSourceUrn || ''} disabled />
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <TextField fullWidth size="small" label='Transporter Name' type="text" value={consignmentdetails?.consignmentOwnerName || ''} disabled />
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <TextField fullWidth size="small" label='Transporter Contact' type="text" value={consignmentdetails?.consignmentOwnerContactNo || ''} disabled />
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <TextField fullWidth size="small" label='Pick-Up Location URN' type="text" value={consignmentsource?.sourceStakeholderUrn || ''} disabled />
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <TextField fullWidth size="small" label='Pick-Up Location Name' type="text" value={consignmentsource?.sourceLocationName || ''} disabled />
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <TextField fullWidth size="small" label='Pick-Up Location Address' type="text" value={consignmentsource?.sourceLocationAddress || ''} disabled />
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <TextField fullWidth size="small" label='SO' type="text" value={consignmentsource?.sourceStakeholderPo || ''} disabled />
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <TextField fullWidth size="small" label='Schedule Line Number' type="text" value={consignmentsource?.scheduleLineNumber || ''} disabled />
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <TextField fullWidth size="small" label='Schedule Delivery Date' type="text" value={consignmentdetails?.scheduleDeliveryTimestamp && Moment(consignmentdetails?.scheduleDeliveryTimestamp).format('DD/MM/YYYY') || ''} disabled />
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <TextField fullWidth size="small" label='Schedule Pick-Up Date' type="text" value={consignmentdetails?.consignmentPickDate && Moment(consignmentdetails?.consignmentPickDate).format('DD/MM/YYYY') || ''} disabled />
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <TextField fullWidth size="small" label='Schedule Consignment Weight(in MT)' type="text" value={Number(consignmentdetails?.scheduledWeight)?.toFixed(4) || ''} disabled />
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <TextField fullWidth size="small" label='Delivery Location Name' type="text" value={consignmentdetails?.consignmentDestinationLocationName || ''} disabled />
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <TextField fullWidth size="small" label='Delivery Location Address' type="text" value={consignmentdetails?.consignmentDestinationLocationAddress || ''} disabled />
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <TextField fullWidth size="small" label='Type of Inventory' type="text" value={consignmentdetails?.materialType || ''} disabled />
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <TextField fullWidth size="small" label='Type Of Loading(FTL/LTL)' type="text" value={consignmentdetails?.typeOfLoading || ''} disabled />
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <TextField fullWidth size="small" label='Driver Name' type="text" value={consignmentdetails?.driverName || ''} disabled />
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <TextField fullWidth size="small" label='Driver License No.' type="text" value={consignmentdetails?.driverLicenseNo || ''} disabled />
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <TextField fullWidth size="small" label='Driver Contact' type="text" value={consignmentdetails?.driverContact || ''} disabled />
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <TextField fullWidth size="small" label='Vehicle Registration' type="text" value={consignmentdetails?.vehicleRegNo || ''} disabled />
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <TextField fullWidth size="small" label='Delivery Location URN' type="text" value={consignmentdetails?.consignmentDestinationStakeholderUrn || ''} disabled />
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <TextField fullWidth
                      required
                      error={errorMessage.pickupTareWeightError}
                      helperText={errorMessage.pickupTareWeightError}
                      size="small"
                      label='Tare weight measured @LLE'
                      type="number"
                      onFocus={handleNumberFieldFocus}
                      name="pickupTareWeight"
                      disabled={consignmentdetails?.isTripStarted === true || consignmentdetails?.isLoadingDone === true || role2 || (role1 && consignmentdetails?.loadingCompleteDate != null)}
                      value={consignmentdetails?.isTripStarted === true || consignmentdetails?.isLoadingDone === true || role2 || (role1 && consignmentdetails?.loadingCompleteDate != null) ? Number(consignmentNoDetails?.pickupTareWeight)?.toFixed(4) || '' : consignmentNoDetails?.pickupTareWeight || ''}
                      onChange={(e) => handleChange(e)}
                      // InputProps={{ maxLength: 6 }}
                      onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '_' || evt.key === '+' || evt.key === '!' || evt.key === '@' || evt.key === '#' || evt.key === '$' || evt.key === '%' || evt.key === '^' || evt.key === '&' || evt.key === '*' || evt.key === '(' || evt.key === ')') && evt.preventDefault()}

                    // oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" 
                    />
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <TextField fullWidth size="small" label='Average Moisture during the pickup' type="number" onFocus={handleNumberFieldFocus}
                      name="totalMoisture"
                      disabled={consignmentdetails?.isTripStarted === true || consignmentdetails?.isLoadingDone === true || (role1 && consignmentdetails?.loadingCompleteDate == null) || role2}
                      value={consignmentdetails?.isTripStarted === true || consignmentdetails?.isLoadingDone === true || (role1 && consignmentdetails?.loadingCompleteDate == null) || role2 ? Number(consignmentdetails?.totalMoisture)?.toFixed(4) || '' : consignmentdetails?.totalMoisture || ''}
                      onChange={(e) => handleChange(e)}
                      // InputProps={{ maxLength: 6 }}
                      required
                      error={errorMessage.totalMoistureError}
                      helperText={errorMessage.totalMoistureError}
                      onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '-' || evt.key === '+') && evt.preventDefault()}
                    />
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <TextField fullWidth size="small"
                      label='Gross weight measured @LLE(in MT)'
                      type="number"
                      onFocus={handleNumberFieldFocus}
                      required
                      error={errorMessage.pickupGrossWeightError}
                      helperText={errorMessage.pickupGrossWeightError}
                      name="pickupGrossWeight"
                      disabled={consignmentdetails?.isTripStarted === true || consignmentdetails?.isLoadingDone === true || (role1 && consignmentdetails?.loadingCompleteDate == null) || role2} value={consignmentdetails?.isTripStarted === true || consignmentdetails?.isLoadingDone === true || (role1 && consignmentdetails?.loadingCompleteDate == null) || role2 ? Number(consignmentNoDetails?.pickupGrossWeight)?.toFixed(4) || '' : consignmentNoDetails?.pickupGrossWeight || ''}
                      onChange={(e) => handleChange(e)}
                      // maxLength={6}
                      onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '-' || evt.key === '+') && evt.preventDefault()}
                    />
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <TextField fullWidth size="small" label='Weight during pickup(in MT)' required error={errorMessage.totalWeightError} helperText={errorMessage.totalWeightError} type="number" name="totalWeight" disabled value={Number(totalWeight)?.toFixed(4)} />
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <TextField fullWidth size="small" label='Weight during pickup from Bundle selection(in MT)' type="number" name="pickupNetWeight" disabled value={Number(totalPickupWeight)?.toFixed(4)} onChange={(e) => handleChange(e)} />
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <TextField fullWidth size="small" label='Odometer Start Reading' required error={errorMessage.odometerReadingError} helperText={errorMessage.odometerReadingError}
                      type="number"
                      name="odometerReading"
                      disabled={consignmentdetails?.isTripStarted === true || (role1 && consignmentdetails?.loadingCompleteDate == null) || role2}
                      value={consignmentNoDetails?.odometerReading || ''}
                      onChange={(e) => handleChange(e)}
                      onFocus={handleNumberFieldFocus}
                      onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '-' || evt.key === '+') && evt.preventDefault()}
                    // InputProps={{ maxLength: 6 }}
                    />
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    {consignmentdetails?.isTripStarted === true ? null :
                      <div>
                        {!role1 && !role2 && <Button disabled={consignmentdetails?.isLoadingDone === true} onClick={onClickBundle} heapSubmitCallbackFunction={selectedHeap}>Select Bundle</Button>}
                      </div>
                    }
                    {!(consignmentdetails?.isTripStarted === true) && (role1 && consignmentdetails?.loadingCompleteDate == null) &&
                      <div>
                        <Button onClick={onClickBundle} heapSubmitCallbackFunction={selectedHeap}>Select Bundle</Button>
                      </div>
                    }
                    <div className="error-msg">
                      {errorMessage.heapError}
                    </div>
                  </Grid>
                  <Divider sx={{
                    width: '105%',
                    bgcolor: 'black',
                    marginTop: '3vh'
                  }} mt={2} />
                  {!(role1 && consignmentdetails?.loadingCompleteDate == null) &&
                    <>
                      <Grid item xs={12} lg={6}>
                        <FormControl fullWidth required error={errorMessage.isHitInspectionChecklistError}>
                          <FormLabel id="demo-row-radio-buttons-group-label">Truck Covered</FormLabel>
                          <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                          >
                            <FormControlLabel name="isHitInspectionChecklist" disabled={consignmentdetails?.isTripStarted === true} checked={consignmentNoDetails?.isHitInspectionChecklist === true} onChange={(e) => radioChange(e, true)} control={<Radio />} label="Yes" />
                            <FormControlLabel name="isHitInspectionChecklist" disabled={consignmentdetails?.isTripStarted === true} checked={consignmentNoDetails?.isHitInspectionChecklist === false} onChange={(e) => radioChange(e, false)} control={<Radio />} label="No" />
                          </RadioGroup>
                          <FormHelperText sx={{ color: 'red' }}>{errorMessage.isHitInspectionChecklistError}</FormHelperText>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} lg={6}>
                        <FormControl fullWidth required error={errorMessage.isProperLashingError}>
                          <FormLabel id="demo-row-radio-buttons-group-label">Proper Lashing</FormLabel>
                          <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                          >
                            <FormControlLabel name="isProperLashing" disabled={consignmentdetails?.isTripStarted === true} checked={consignmentNoDetails?.isProperLashing === true} onChange={(e) => radioChange(e, true)} control={<Radio />} label="Yes" />
                            <FormControlLabel name="isProperLashing" disabled={consignmentdetails?.isTripStarted === true} checked={consignmentNoDetails?.isProperLashing === false} onChange={(e) => radioChange(e, false)} control={<Radio />} label="No" />
                          </RadioGroup>
                          <FormHelperText sx={{ color: 'red' }}>{errorMessage.isProperLashingError}</FormHelperText>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} lg={6}>
                        <FormControl fullWidth required error={errorMessage.isPayloadWithinCapacityError}>
                          <FormLabel id="demo-row-radio-buttons-group-label">Payload Within Capacity Limits</FormLabel>
                          <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                          >
                            <FormControlLabel name="isPayloadWithinCapacity" disabled={consignmentdetails?.isTripStarted === true} checked={consignmentNoDetails?.isPayloadWithinCapacity === true} onChange={(e) => radioChange(e, true)} control={<Radio />} label="Yes" />
                            <FormControlLabel name="isPayloadWithinCapacity" disabled={consignmentdetails?.isTripStarted === true} checked={consignmentNoDetails?.isPayloadWithinCapacity === false}
                              onChange={(e) => radioChange(e, false)} control={<Radio />} label="No" />
                          </RadioGroup>
                          <FormHelperText sx={{ color: 'red' }}>{errorMessage.isPayloadWithinCapacityError}</FormHelperText>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} lg={6}>
                        <FormControl fullWidth required error={errorMessage.isPayloadHeightExceedLimitError}>
                          <FormLabel id="demo-row-radio-buttons-group-label">Payload Height Exceeding Limit</FormLabel>
                          <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                          >
                            <FormControlLabel name="isPayloadHeightExceedLimit" disabled={consignmentdetails?.isTripStarted === true} checked={consignmentNoDetails?.isPayloadHeightExceedLimit === true}
                              onChange={(e) => radioChange(e, true)} control={<Radio />} label="Yes" />
                            <FormControlLabel name="isPayloadHeightExceedLimit" disabled={consignmentdetails?.isTripStarted === true} checked={consignmentNoDetails?.isPayloadHeightExceedLimit === false}
                              onChange={(e) => radioChange(e, false)} control={<Radio />} label="No" />
                          </RadioGroup>
                          <FormHelperText sx={{ color: 'red' }}>{errorMessage.isPayloadHeightExceedLimitError}</FormHelperText>
                        </FormControl>
                      </Grid>
                    </>}
                  <Divider sx={{
                    width: '105%',
                    bgcolor: 'black',
                    marginTop: '3vh'
                  }} mt={2} />
                  <Grid item xs={12} lg={12}>
                    <Typography variant="h5" gutterBottom>Raw Bamboo Issue</Typography>
                    {newArrayList.length !== 0 ?
                      <Box style={{ height: 300, width: '100%' }}>
                        {
                          newArrayList &&
                          <DataGrid rows={newArrayList}
                            columns={columns}
                            pageSize={10}
                            getRowId={(row) => row.bundleId}
                            components={{ Toolbar: QuickSearchToolbar }}
                          />
                        }
                      </Box>
                      : <Typography display="flex" justifyContent='center'>{NO_DATA_AVAILABLE}</Typography>
                    }
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField fullWidth
                      autoComplete="off"
                      id="outlined-multiline-static"
                      label="Comments"
                      multiline
                      rows={4}
                      name="pickupComments"
                      onChange={(e) => onTextValueChange(e)}
                      value={addComment}
                      disabled={consignmentdetails?.isTripStarted === true}
                      sx={{ paddingRight: '15%' }}
                    />
                    <div style={{ display: 'flex', justifyContent: 'flex-end', paddingRight: '10%' }}>
                      <Badge bg={`${addComment?.length > characterLimit ? 'danger' : 'primary'}`}>{addComment?.length}/{characterLimit}</Badge>
                    </div>
                  </Grid>
                  <Grid item xs={12}>
                    <Box style={{ height: 200, width: '100%' }}>
                      <DataGrid
                        rows={[{ action: "Pick-up", comment: consignmentNoDetails.pickupComments }]?.map((item) => ({ ...item, id: uuidv4() }))}
                        columns={commentColumns}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
        <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
          {(localStorage.getItem('role') == PIT_ROLES.PitScmUser || stakeholderDetails) &&
            <>
              {consignmentdetails?.isTripStarted === true || consignmentdetails?.isLoadingDone === true ? null :
                <Button sx={{ minWidth: 100, ml: 1 }} variant="contained" onClick={(e) => onSave(e)}>Save</Button>}
              {consignmentdetails?.isTripStarted === true ? null :
                <Button sx={{ minWidth: 100, ml: 1 }} variant="contained" onClick={(e) => onStart(e)}>Start Trip To Destination</Button>
              }
              {consignmentdetails?.loadingCompleteDate != null && consignmentdetails?.isDeliveryChallanCreated === false ?
                <Button sx={{ minWidth: 100, ml: 1 }} variant="contained" onClick={(e) => onDeliveryChallan(e)}>Create Delivery Challan</Button>
                : null
              }
              {consignmentdetails?.loadingCompleteDate != null && consignmentdetails?.isLoadingDone === true ? null :
                <Button sx={{ minWidth: 100, ml: 1 }} variant="contained" onClick={(e) => onLoading(e)}>Loading Completed</Button>
              }

              {consignmentdetails?.delieryChallanNumber != null ?
                <>
                  <Button sx={{ minWidth: 100, ml: 1 }} variant="contained" onClick={() => getDownloadChallan("download")}>Download</Button>
                  <Button sx={{ minWidth: 100, ml: 1 }} variant="contained" onClick={() => getDownloadChallan("print")}>Print</Button>
                </>
                : null
              }
            </>
          }
        </Box>
      </Container>

      <ConfirmationPopover onOpen={confirmOpen} onConfirm={onConfirmSave} onClose={handleConfirmClose} action="Save" />
      <ConfirmationPopover onOpen={confirmOpen2} onConfirm={onConfirmCreateDeliveryChallan} onClose={handleConfirmClose2} action="Create Delivery Challan" />
      <ConfirmationPopover onOpen={confirmOpen3} onConfirm={onConfirmStartTrip} onClose={handleConfirmClose3} action="Start Trip To Destination" />
      <ConfirmationPopover onOpen={confirmOpen4} onConfirm={onConfirmLoadingCompleted} onClose={handleConfirmClose4} action="Loading Completed" />

      <Dialog maxWidth='md' fullWidth open={logModalOpen4}>
        <DialogContent>
          <BundleDetailsPopOver inventories={setInventories} rbInventories={rbInventories} handleLogModalClose={handleLogModalClose4} />
        </DialogContent>
      </Dialog>
    </>
  )
}
export default LleTracker;
